export var thirdPartyPOADetailsMapper = function (data) {
    var result = {
        accode: "",
        acName: "",
        companyName: ""
    };
    if (data) {
        return {
            accode: data.accode,
            acName: data.acName,
            companyName: data.companyName
        };
    }
    return result;
};
